import {
  CreateBreakSettingDocument,
  CreateBreakSettingMutationVariables,
  FetchBreakSettingsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateAttendanceBreakSetting = () => {
  const [createBreakSetting, { loading }] = useMutation(CreateBreakSettingDocument, {
    extractorFn: (data) => data.attendanceMutations.createAttendanceBreakSetting,
  })

  const create = (variables: CreateBreakSettingMutationVariables) => {
    return createBreakSetting({
      variables,
      refetchQueries: [FetchBreakSettingsDocument],
    })
  }

  return {
    loading,
    create,
  }
}
